/* eslint-disable @typescript-eslint/no-explicit-any */
import { TFunction } from 'i18next';

/**
 * Safely translates a key with fallback to default text
 */
export const safeTranslate = (
  t: TFunction,
  key: string,
  options?: object,
  fallback?: string
): string => {
  try {
    const translation = t(key, options as any);
    return translation !== key ? translation : fallback || key;
  } catch (error) {
    console.warn(`Translation failed for key: ${key}`, error);
    return fallback || key;
  }
};

// Default translation strings for when a translation function is not available
// These will be used at build time and replaced at runtime
export const DEFAULT_TRANSLATIONS = {
  instaview: {
    signIn: 'Sign In',
    welcomeText: 'Welcome to InstaVision'
  },
  luna: {
    signIn: 'Sign In',
    welcomeText: 'Welcome to Luna AI'
  },
  newaieye: {
    signIn: 'Sign In',
    welcomeText: 'Welcome to NewAIEye'
  }
};
